export const REPLY_PREVIEW_LIMIT = 3;

export function groupTaskComments(comments) {
  const list = Array.isArray(comments) ? comments : [];
  const roots = list.filter((comment) => comment.parent_id == null);
  return roots.map((root) => ({
    root,
    replies: list
      .filter((comment) => comment.parent_id === root.id)
      .slice()
      .sort((a, b) => String(a.created_at || "").localeCompare(String(b.created_at || ""))),
  }));
}

export function visibleReplies(replies, expanded) {
  const list = Array.isArray(replies) ? replies : [];
  if (expanded || list.length <= REPLY_PREVIEW_LIMIT) return list;
  return list.slice(0, REPLY_PREVIEW_LIMIT);
}

export function hiddenReplyCount(replies, expanded) {
  const list = Array.isArray(replies) ? replies : [];
  if (expanded || list.length <= REPLY_PREVIEW_LIMIT) return 0;
  return list.length - REPLY_PREVIEW_LIMIT;
}

export function stripCommentThread(comments, commentId) {
  return (comments || []).filter(
    (comment) => comment.id !== commentId && comment.parent_id !== commentId
  );
}
